import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import { AccountingFilter } from 'v2-types/order';

export type GQLGetOrderMortgagePayoffs = {
  getOrder: {
    mortgages: {
      _id: string
      loan_number: string,
      estate: { _id: string },
      accounting: {
        amount
        code
      }[]
    }[]
  }
};

export const getOrderMortgagePayoffs = async (
  payload: {
    id: string,
    filters?: {[key: string]: AccountingFilter}
  }
) => {
  const query = gql`
    query GetOrder($id: ID!, $filters: OrderFilters) {
      getOrder(_id: $id, filters: $filters) {
        estates {
          _id
        }
        accounting {
          _id
        }
        mortgages {
          _id
          loan_number
          estate {
            _id
          }
          accounting {
            amount
            code
          }
        }
      }
    }
  `;
  const response = await graphQLClient()
    .request<GQLGetOrderMortgagePayoffs>(query, payload);

  return response;
};